import React from 'react';
import noNotificationImg from '../../assets/img/nonotification.png';

function NoNotification() {
    return (
        <>
            
            <div className="text-center">
                {/* <img src={noNotificationImg} alt="No notifications"   /> */}
                <p className="text-muted">No notification right now</p>
              
            </div>
        </>
    );
}

export default NoNotification;
